import { useId } from 'react';

export default function Gem({ className = '' }: { className?: string }) {
  const id = useId().replace(/:/g, '');
  const body = `${id}-gemBody`;
  const facet = `${id}-gemFacet`;

  return (
    <svg
      viewBox="0 0 16 16"
      className={`inline-block h-3.5 w-3.5 shrink-0 align-[-0.125em] ${className}`}
      aria-hidden
      focusable="false"
    >
      <defs>
        <linearGradient id={body} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#7ec8e8" />
          <stop offset="40%" stopColor="#3d7ea6" />
          <stop offset="100%" stopColor="#1e4a66" />
        </linearGradient>
        <linearGradient id={facet} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#d7f1ff" stopOpacity="0.85" />
          <stop offset="100%" stopColor="#d7f1ff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M8 1.4 13.6 5.2 11.8 13.4H4.2L2.4 5.2 8 1.4z"
        fill={`url(#${body})`}
        stroke="#1a3d54"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
      <path d="M8 1.4 13.6 5.2H2.4L8 1.4z" fill="#9ad4ef" fillOpacity="0.55" />
      <path d="M8 1.4 8 13.4 4.2 13.4 2.4 5.2 8 1.4z" fill="#000" fillOpacity="0.12" />
      <path d="M8 1.4 5.4 5.2 8 13.4 10.6 5.2 8 1.4z" fill={`url(#${facet})`} />
      <path
        d="M4.6 5.5h6.8"
        stroke="#e8f7ff"
        strokeOpacity="0.35"
        strokeWidth="0.5"
      />
    </svg>
  );
}
